import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=5e4e33ab&scoped=true&"
var script = {}
import style0 from "./foot.scss?vue&type=style&index=0&id=5e4e33ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e33ab",
  null
  
)

export default component.exports